export default {
      id: "Alt1-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Alt1",
      toString: function () {
        return this.url;
      }
    }